export default {
  dismiss: {
    id: 'outlet_intro_dismiss',
    defaultMessage: 'Dismiss',
  },
}
